if (!customElements.get('blackland-refined-recipes')) {
  customElements.define('blackland-refined-recipes', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.tabs = [...this.querySelectorAll('[data-recipe-tab]')];
      this.panels = [...this.querySelectorAll('[data-recipe-panel]')];
      this.tablist = this.querySelector('[role="tablist"]');
      if (this.tabs.length < 2 || this.tabs.length !== this.panels.length || !this.tablist) return;

      this.panels.forEach((panel, index) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', this.tabs[index].id);
        panel.tabIndex = 0;
      });
      this.tablist.hidden = false;
      this.classList.add('is-enhanced');
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index), { signal });
        tab.addEventListener('keydown', event => {
          let next;
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          if (event.key === 'ArrowRight') next = (index + direction + this.tabs.length) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - direction + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          // Manual activation: arrows move focus; Enter/Space use native button click.
          this.tabs[next].focus({ preventScroll: true });
        }, { signal });
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.recipeBlock === String(event.detail?.blockId));
        if (index >= 0) this.activate(index);
      }, { signal });

      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.tablist);
      this.activate(0, false);
    }

    activate(index, animate = true) {
      if (!this.panels[index] || (animate && this.activeIndex === index)) return;
      this.activeIndex = index;
      this.tabs.forEach((tab, current) => {
        const selected = current === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        // The entire server-rendered record changes together, including photo and links.
        this.panels[current].hidden = !selected;
        this.panels[current].classList.toggle('is-entering', selected && animate);
      });
      this.measure();
    }

    measure() {
      this.style.setProperty('--bl-food-tabs-height', `${this.tablist.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
